import { roleMembersHistory } from "./RoleMembersHistory.slice";

export const roleMembersHistoryActions = { ...roleMembersHistory.actions };
